var path = '/shared/javascripts/templates/sub_nav/layout.html';
var html = "<ng-transclude></ng-transclude>\n";
window.angular.module('tiz').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;